<mat-sidenav-container>
    <mat-sidenav #sidenav [opened]="sidenavOpen" [mode]="sidenavOpen ? 'side' : 'over'" perfectScrollbar
        class="account-sidenav"  *ngIf="!isMobile">
        <mat-nav-list class="mat-elevation-z1 h-100">
            <app-account-side-menu *ngIf = "sidenavMenuItems['desktop_links']" [menuItems]="sidenavMenuItems['desktop_links']" [menuParentId]="0" (emitPass)="handleChange($event)" fxShow="false" fxShow.gt-sm></app-account-side-menu> 
            
            <!-- <mat-list-item *ngFor="let link of links">              
                <mat-icon matListIcon class="mat-icon-sm">{{link.icon}}</mat-icon>
                <a matLine [routerLink]="link.href" routerLinkActive="horizontal-active-link" 
                [routerLinkActiveOptions]="{exact:true}">{{ link.name }}</a>
            </mat-list-item> -->
        </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="account-content" ngClass.gt-sm="p-left">
        <!-- Cut-Off Time Message For Desktop -->
        <div fxLayout="row" fxLayoutAlign="flex-start center" fxShow="false" fxShow.gt-sm 
            *ngIf="router.url === '/account/orders' && isShowCutOffMessage">
            <div class="cut-off-message-container mb-5px" fxLayout="row" fxLayoutAlign="space-between center" 
            fxLayoutGap="5px" *ngIf="!!formattedDateTime">
                <span class="message">
                    Order cut-off time is {{formattedDateTime}}
                </span>
                <i class="material-icons close-button" data-icon="close" (click)="closeCutOffMessage()"></i>
                <!-- <mat-icon class="close-button" (click)="closeCutOffMessage()">close</mat-icon> -->
            </div>
        </div>
        <!-- End -->
         <ng-container *ngIf="!!featureTags && featureTags['ftag_cod_and_other_payment_for_sf']">
            <div fxLayout="row" fxLayoutAlign="space-between center" 
                class="header-row mat-elevation-z1 text-muted"
                *ngIf="!isMobile && router.url !== '/account/orders' && router.url !== '/account/recurring' && router.url !== '/account/bulletinboard' && router.url !== '/account/pre-orders' && router.url !== '/account/vacation' && router.url !== '/account/my-membership'">
                <button *ngIf="!sidenavOpen" mat-icon-button (click)="sidenav.toggle()">
                    <i class="material-icons " data-icon="more_vert"></i>
                </button>
                <h3 *ngIf="!!menuTitle">{{menuTitle}}</h3>
            </div>
         </ng-container>
         <ng-container *ngIf="!!featureTags && !featureTags['ftag_cod_and_other_payment_for_sf']">
         <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_delivery_preference_design_issue']">
            <div fxLayout="row" fxLayoutAlign="space-between center" 
                class="header-row mat-elevation-z1 text-muted"
                *ngIf="!isMobile && router.url !== '/account/orders' && router.url !== '/account/recurring' && router.url !== '/account/bulletinboard' && router.url !== '/account/pre-orders' && router.url !== '/account/vacation' && router.url !== '/account/my-membership' && router.url !== '/account/addresses'">
                <button *ngIf="!sidenavOpen" mat-icon-button (click)="sidenav.toggle()">
                    <i class="material-icons " data-icon="more_vert"></i>
                </button>
                <h3>My Account</h3>
            </div>
         </ng-container>
         <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_delivery_preference_design_issue']">
            <div fxLayout="row" fxLayoutAlign="space-between center" 
                class="header-row mat-elevation-z1 text-muted"
                *ngIf="!isMobile && router.url !== '/account/orders' && router.url !== '/account/recurring' && router.url !== '/account/bulletinboard' && router.url !== '/account/pre-orders' && router.url !== '/account/vacation' && router.url !== '/account/my-membership'">
                <button *ngIf="!sidenavOpen" mat-icon-button (click)="sidenav.toggle()">
                    <i class="material-icons " data-icon="more_vert"></i>
                </button>
                <h3>My Account</h3>
            </div>
         </ng-container>
        </ng-container>

        <div class="account-wrapper" [ngClass]="{'mat-elevation-z1' : router.url !== '/account/addresses'}"
        [class.mt-0px]="isMobile || router.url === '/account/orders' || router.url === '/account/recurring'">
            <router-outlet></router-outlet>
         </div>
        <!-- Cut-Off Time Message For Mobile -->
        <div fxLayout="row" fxLayoutAlign="center center" fxShow="false" fxShow.lt-md 
            *ngIf="router.url === '/account/orders' && isShowCutOffMessage">
            <div class="cut-off-message-container mt-1 mb-5px" fxLayout="row" fxLayoutAlign="space-between center" 
                fxLayoutGap="5px" *ngIf="!!formattedDateTime">
                <span class="message">
                    Order cut-off time is {{formattedDateTime}}
                </span>
                <i class="material-icons close-button" data-icon="close" (click)="closeCutOffMessage()"></i>
                <!-- <mat-icon class="close-button" (click)="closeCutOffMessage()">close</mat-icon> -->
            </div>
        </div>
        <!-- End -->
    </mat-sidenav-content>
</mat-sidenav-container>